import * as React from 'react';
import { EActiveView } from '../../types/view';
import { formatPhone } from '../../utils/formatString';
import { PhoneSmsConfirmationInfo } from '../../_NEXT_components/PhoneSmsConfirmationInfo';
export function PhoneSmsConfirmationInfoContainer(_ref) {
  var phone = _ref.phone,
      allowEdit = _ref.allowEdit,
      changeView = _ref.changeView,
      resetAgreement = _ref.resetAgreement;
  var formattedPhone = React.useMemo(function () {
    return formatPhone(phone);
  }, [phone]);

  var handleEditPhoneClick = function handleEditPhoneClick(e) {
    e.preventDefault();
    resetAgreement();
    changeView(EActiveView.PhoneAuth);
  };

  return /*#__PURE__*/React.createElement(PhoneSmsConfirmationInfo, {
    phone: formattedPhone,
    onEditPhoneClick: allowEdit ? handleEditPhoneClick : undefined
  });
}